module.exports = "<div class=\"spinner soldicon\">\n    <div class=\"rect1\"></div>\n    <div class=\"rect2\"></div>\n    <div class=\"rect3\"></div>\n    <div class=\"rect4\"></div>\n    <div class=\"rect5\"></div>\n    <div class=\"rect6\"></div>\n    <div class=\"rect7\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/spinner/spinner.component.html
// module id = ./src/app/spinner/spinner.component.html
// module chunks = main